import { useState, useRef, useCallback, useEffect } from 'react';

function useTapReveal(options = {}) {
  const { onReveal, onDismiss, refs, enabled = true } = options;
  const [revealed, setRevealed] = useState(false);
  const onRevealRef = useRef(onReveal);
  const onDismissRef = useRef(onDismiss);
  onRevealRef.current = onReveal;
  onDismissRef.current = onDismiss;
  const reveal = useCallback(() => {
    setRevealed((wasRevealed) => {
      if (!wasRevealed) onRevealRef.current?.();
      return true;
    });
  }, []);
  const dismiss = useCallback(() => {
    setRevealed((wasRevealed) => {
      if (wasRevealed) onDismissRef.current?.();
      return false;
    });
  }, []);
  const onPointerDown = useCallback(
    (e) => {
      if (!enabled || e.pointerType === "mouse") return;
      if (revealed) dismiss();
      else reveal();
    },
    [enabled, revealed, reveal, dismiss]
  );
  useEffect(() => {
    if (!revealed || typeof document === "undefined") return;
    const onDocDown = (ev) => {
      const target = ev.target;
      if (!(target instanceof Node)) return;
      const inside = (refs ?? []).some((r) => r.current?.contains(target));
      if (!inside) dismiss();
    };
    const id = setTimeout(() => document.addEventListener("pointerdown", onDocDown), 0);
    return () => {
      clearTimeout(id);
      document.removeEventListener("pointerdown", onDocDown);
    };
  }, [revealed, refs, dismiss]);
  return { revealed, triggerProps: { onPointerDown }, reveal, dismiss };
}

export { useTapReveal };
